export class RelatorioRevendaModel {
    constructor(
        public revendaId: string = '',
        public nomeComercial: string = '',
        public ativos: number = 0,
        public inativos: number = 0,
        public anoMes: number = 0,
        public grupo: 'A' | 'B' | 'C' = 'C'
    ) { }
}